import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const TrainingServices = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Training Services – Inspection and Certification</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) provides specialized training services to enhance knowledge and skills 
            in inspection, certification, and standards compliance.
          </p>
          <p className="subtitle">
            Our training programs equip professionals, industries, and regulators with practical expertise to ensure quality, safety, 
            and regulatory compliance.
          </p>
        </div>
      </section>

      {/* === Training Services Section === */}
      <section className="intro-section">
        <h2 className="section-title">Training Services Offered</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Inspection procedures and techniques for product and material compliance</li>
              <li>Certification processes and requirements for various management systems</li>
              <li>Non-Destructive Testing (NDT) and metrology training</li>
              <li>Quality management systems (ISO 9001) and regulatory compliance training</li>
              <li>Workshops on standards interpretation and application in industry</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Market surveillance and consumer protection practices</li>
              <li>Training on drafting and implementing national and international standards</li>
              <li>Environmental and safety management systems (ISO 14001, ISO 45001)</li>
              <li>Technical guidance and best practices for laboratory testing and certification</li>
              <li>Customized industry-specific training programs on request</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Calendar and Scheduling Section === */}
      <section className="functions-section">
        <h2 className="section-title">Training Calendar & Scheduling</h2>
        <p>
          MBS releases a detailed training calendar outlining scheduled sessions, venues, and registration procedures. 
          Participants can register for workshops and courses that are relevant to their industry, sector, or professional development goals.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Training Services</h2>
        <p>
          For inquiries, registration, or further information about inspection and certification training, 
          please contact the MBS Training Department.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:training@mbs.mw">training@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 666</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          MBS Training Services empower stakeholders with practical skills and knowledge to ensure compliance, 
          quality, and safety in products, services, and industrial operations.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default TrainingServices;
